import React from 'react';
import { IonText } from '@ionic/react';
import './FormError.css';

interface Props {
  message: string;
  color?: string;
}

const FormError = ({ message, color = 'secondary' }: Props) => {
  return (
    <IonText color={color} className="form-error ion-padding-horizontal">
      {message}
    </IonText>
  );
};

export default FormError;
